import { render, staticRenderFns } from "./TextareaElement.vue?vue&type=template&id=dd77e93e&"
import script from "./TextareaElement.vue?vue&type=script&lang=js&"
export * from "./TextareaElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports